﻿import { defineStore } from 'pinia'
import { msg$ } from '../enums'

/**
 * messenge popup 
 **/
export const useMessenger = defineStore('app.messenger', {
    state: () => {
        return {
            messages: [] as any[],
            id: 0,
        }
    },
    getters: {
    //    //是否有message alive
        isBusy: (state) => { return state.messages.length > 0 }
    },
    actions: {
        /**
         * 送出顯示Error資料
         * @param payload
         */
        pushError(payload: any) {
            const { msg, callback } = payload;

            this.$patch((state: any) => {
                state.messages.push({
                    severity: msg$.error,
                    content: msg,
                    id: state.id++,
                    onClose: callback.onErrorClose
                })
            });
        },
        /**
         * 送出顯示Warn資料
         * @param payload
         */
        pushWarn(payload: any) {
            const { msg, callback } = payload;

            this.$patch((state: any) => {
                state.messages.push({
                    severity: msg$.warn,
                    content: msg,
                    id: state.id++,
                    onClose: callback.onWarnClose
                })
            });
        },
        /**
         * 送出顯示Info資料
         * @param payload
         */
        pushInfo(payload: any) {
            const { msg, callback } = payload;

            this.$patch((state: any) => {
                state.messages.push({
                    severity: msg$.info,
                    content: msg,
                    id: state.id++,
                    onClose: callback.onInfoClose
                })
            });
        },
        /**
         * 送出顯示Success資料
         * @param payload
         */
        pushSuccess(payload: any) {
            const { msg, callback } = payload;

            this.$patch((state: any) => {
                state.messages.push({
                    severity: msg$.success,
                    content: msg,
                    id: state.id++,
                    onClose: callback.onSuccessClose
                })
            });
        },
        /**
         * 移除指定顯示資料
         * @param payload
         */
        removeMessage(payload: any) {
            const index = this.messages.indexOf(payload);
            if (index > -1) {
                this.$patch((state) => state.messages.splice(index, 1));
            }
        },
        /**
         * 移除所有顯示資料
         **/
        clearMessages() {
            this.messages.length = 0;
        }
    }
});
